
import type { ReactNode } from 'react'

type ButtonVariant = 'gradient' | 'black' | 'green'

interface GradientButtonProps {
  link?: string
  btntext: ReactNode
  onClick?: () => void
  targetBlank?: boolean
  variant?: ButtonVariant
  id?: string
}

interface VariantStyle {
  text: string
  border: string
  hoverBg: string
  bg: string
  text_weight: string
}

const variants: Record<ButtonVariant, VariantStyle> = {
  gradient: {
    text: 'text-[#2EC4F3]',
    border: 'border border-[#2EC4F3]',
    hoverBg: 'bg-gradient-to-r from-[#2EC4F3] to-[#BFD633]',
    bg: 'bg-white',
    text_weight: 'font-bold',
  },
  black: {
    text: 'text-black',
    border: 'border border-black',
    hoverBg: 'bg-black',
    bg: 'bg-white',
    text_weight: 'font-bold',
  },
  green: {
    text: 'text-black',
    border: '',
    hoverBg: 'bg-black',
    bg: 'bg-[#BFD633]',
    text_weight: 'font-medium',
  },
}

export default function Grediantbutton({
  link,
  btntext,
  onClick,
  targetBlank = false,
  variant = 'gradient',
  id = '',
}: GradientButtonProps) {
  const current = variants[variant]

  const sharedClasses = `relative overflow-hidden px-8 py-3 rounded-full cursor-pointer transition-all duration-500 shadow-md group ${current.bg} ${current.text} ${current.border} ${current.text_weight}`

  const content = (
    <>
      <span
        className={`absolute inset-0 ${current.hoverBg} translate-x-[-101%] group-hover:translate-x-0 transition-transform duration-500 ease-out rounded-full`}
      />
      <span className="relative z-10 left-0 transition-colors duration-300 group-hover:text-white">
        {btntext}
      </span>
    </>
  )

  if (link) {
    return (
      <a
        href={link}
        target={targetBlank ? '_blank' : undefined}
        rel={targetBlank ? 'noopener noreferrer' : undefined}
        id={id}
        className={`${sharedClasses} inline-flex items-center justify-center no-underline`}
      >
        {content}
      </a>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      id={id}
      className={sharedClasses}
    >
      {content}
    </button>
  )
}

